// Import micromodal
import MicroModal from 'micromodal';  // es6 module

// Import Globe Animation
import './globe.js'

// AOS - Animate on scroll library
// import AOS from 'aos';
// AOS.init({
// 	// Global settings:
// 	disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
// 	startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
// 	initClassName: 'aos-init', // class applied after initialization
// 	animatedClassName: 'aos-animate', // class applied on animation
// 	useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
// 	disableMutationObserver: false, // disables automatic mutations' detections (advanced)
// 	debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
// 	throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
// 	// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
// 	offset: 120, // offset (in px) from the original trigger point
// 	delay: 0, // values from 0 to 3000, with step 50ms
// 	duration: 400, // values from 0 to 3000, with step 50ms
// 	easing: 'ease', // default easing for AOS animations
// 	once: false, // whether animation should happen only once - while scrolling down
// 	mirror: false, // whether elements should animate out while scrolling past them
// 	anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
// });

document.addEventListener('DOMContentLoaded', () => {

	// Initialize MicroModal
	// Currently, you can find a demo micromodal in the page-tempalate.php file
	MicroModal.init({
		openTrigger: 'data-custom-open',
		disableScroll: false,
		awaitCloseAnimation: true
	})
});

// Alpine.js
// https://alpinejs.dev/
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
Alpine.plugin(intersect);
window.Alpine = Alpine;
Alpine.start();

// import Swiper styles and modules styles
// import Swiper JS
// https://swiperjs.com/
import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade, Navigation } from 'swiper/modules';

const testimonial01 = new Swiper('.testimonial-01', {
    // configure Swiper to use modules
    modules: [Pagination, Autoplay],
    loop: true,
    spaceBetween: 50,
    centeredSlides: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3,
      },
    },
  });

const servicesWebDesign = new Swiper('.services-web-design', {
  modules: [Autoplay, EffectFade, Pagination, Navigation],
  loop: true,
  spaceBetween: 30,
  effect: "fade",
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});


// Vanilla Tilt
// https://github.com/micku7zu/vanilla-tilt.js
import VanillaTilt from 'vanilla-tilt';


// ScrollReveal library
// https://scrollrevealjs.org/
import ScrollReveal from 'scrollreveal';
/*========== SCROLL REVEAL ANIMATION ==========*/
window.sr = ScrollReveal({
    distance: '60px',
    duration: 2800,
    reset: false
});

sr.reveal(`.animate_top`, {
    origin: 'top',
    interval: 100,
})

sr.reveal(`.animate_left`, {
  origin: 'left',
  interval: 100,
});

sr.reveal(`.animate_right`, {
    origin: 'right',
    interval: 100,
})

// Document Loaded
document.addEventListener('DOMContentLoaded', () => {});





